import SignUpBreadcrumbs from './SignUpBreadcrumbs'

export default SignUpBreadcrumbs
